/**
 * Moderation page — config only. Component in ModerationPage.tsx so edits get Fast Refresh.
 */

import { Users } from "lucide-react"
import ModerationPage from "./ModerationPage"

export const hitl = {
  title: "Moderation",
  description: "Moderate and manage conversations",
  route: "/moderation",
  url: "/moderation",
  icon: Users,
  component: ModerationPage,
  group: "chats",
  resource: "hitl",
  action: "read",
} satisfies PageConfig
